<div class="loading-container" [class.visible]="loading">
	<div class="loading-spinner"></div>
</div>
<div id="external_form" [class.forced-height]="loading" [class.iframe-padding]="quote.finance_provider_id === 2"></div>
